import contactsIcon from 'assets/image/icons/svg/icons/contacts.svg'
import { CONSTS } from 'config/objectConst'
import { useMemo } from 'react'
import { Link, useParams } from 'react-router-dom'
import { appSelectors } from 'redux/reducers/app'
import { useAppSelector } from 'shared/hooks'
import { Button } from 'shared/ui'

import css from './style.module.scss'

export function SubActions({
	contactsLabel,
	showContactIcon = false
}: { contactsLabel: string; showContactIcon?: boolean }) {
	const { id } = useParams<{ id: string }>()
	const allowHubSpot = useAllowHubSpot()

	const startLink = `/campaigns/${id}`

	return (
		<div className={css.subActions}>
			<Button
				as={Link}
				className={css.action}
				to={`${startLink}/contacts`}
				variant='bordered-dark'
			>
				{showContactIcon && <img alt='contacts-icon' src={contactsIcon} />}

				<span>{contactsLabel}</span>
			</Button>

			{allowHubSpot && (
				<Button
					as={Link}
					className={css.action}
					to={`${startLink}/hubspot`}
					variant='bordered-dark'
				>
					HubSpot
				</Button>
			)}
		</div>
	)
}

function useAllowHubSpot() {
	const teamId = useAppSelector(
		state => appSelectors.persona(state)?.teamId ?? ''
	)

	return useMemo(
		() =>
			CONSTS.BETA_FEATURES.HUBSPOT_INTEGRATION_TEAMS.some(
				id => id === 'any' || id === teamId
			),
		[teamId]
	)
}
